module.exports = function (md) {
  const commentOpener = '<!--';
  const commentRegExp = new RegExp('<!--.*?-->', 'g');

  md.inline.ruler.before(
    'text',
    'comment_inline',
    (state, silent) => {
      const pos = state.pos;
      const max = state.posMax;
      if (state.src.slice(pos, commentOpener.length) !== commentOpener) {
        return;
      }

      const match = state.src.slice(pos, max).match(commentRegExp);
      if (!match) {
        return;
      }

      if (silent) {
        return false;
      }

      const token = state.push('html_block', '', 0);
      token.content = state.src.slice(pos, pos + match[0].length);

      state.pos += match[0].length;

      return true;
    }
  );
};
